import React from 'react';

// PixelIcons.jsx — 8x8 sprite SVG components
const PixelIcons = (() => {
  const Sprite = ({ size = 24, color, glow, children }) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 8 8"
      style={{
        shapeRendering: "crispEdges",
        imageRendering: "pixelated",
        filter: glow ? `drop-shadow(0 0 4px ${glow})` : undefined,
        color: color,
      }}
    >{children}</svg>
  );

  const Heart = (props) => (
    <Sprite color="#FD1491" glow="rgba(253,20,145,0.6)" {...props}>
      <g fill="currentColor">
        <rect x="1" y="1" width="2" height="1"/><rect x="5" y="1" width="2" height="1"/>
        <rect x="0" y="2" width="3" height="2"/><rect x="5" y="2" width="3" height="2"/>
        <rect x="1" y="4" width="6" height="1"/><rect x="2" y="5" width="4" height="1"/>
        <rect x="3" y="6" width="2" height="1"/>
      </g>
    </Sprite>
  );

  const Coin = (props) => (
    <Sprite color="#FDB115" glow="rgba(253,177,21,0.6)" {...props}>
      <g fill="currentColor">
        <rect x="2" y="1" width="4" height="1"/><rect x="1" y="2" width="6" height="1"/>
        <rect x="1" y="3" width="6" height="2"/><rect x="1" y="5" width="6" height="1"/>
        <rect x="2" y="6" width="4" height="1"/>
      </g>
      <rect x="3" y="2" width="1" height="4" fill="#2A003D"/>
    </Sprite>
  );

  const Star = (props) => (
    <Sprite color="#FDB115" glow="rgba(253,177,21,0.6)" {...props}>
      <g fill="currentColor">
        <rect x="3" y="0" width="2" height="2"/>
        <rect x="0" y="2" width="8" height="1"/>
        <rect x="1" y="3" width="6" height="1"/>
        <rect x="2" y="4" width="4" height="1"/>
        <rect x="1" y="5" width="2" height="1"/><rect x="5" y="5" width="2" height="1"/>
        <rect x="0" y="6" width="2" height="1"/><rect x="6" y="6" width="2" height="1"/>
      </g>
    </Sprite>
  );

  const Diamond = (props) => (
    <Sprite color="#00E8CB" glow="rgba(0,232,203,0.6)" {...props}>
      <g fill="currentColor">
        <rect x="3" y="0" width="2" height="1"/>
        <rect x="2" y="1" width="4" height="1"/>
        <rect x="1" y="2" width="6" height="1"/>
        <rect x="0" y="3" width="8" height="1"/>
        <rect x="1" y="4" width="6" height="1"/>
        <rect x="2" y="5" width="4" height="1"/>
        <rect x="3" y="6" width="2" height="1"/>
      </g>
    </Sprite>
  );

  const Joystick = (props) => (
    <Sprite color="#FD1491" {...props}>
      <g fill="currentColor">
        <rect x="2" y="0" width="4" height="1"/>
        <rect x="3" y="1" width="2" height="2"/>
      </g>
      <rect x="1" y="3" width="6" height="3" fill="#00E8CB"/>
      <rect x="0" y="6" width="8" height="1" fill="#fff"/>
    </Sprite>
  );

  const Mushroom = (props) => (
    <Sprite color="#FD1491" {...props}>
      <g fill="currentColor">
        <rect x="2" y="0" width="4" height="1"/>
        <rect x="1" y="1" width="6" height="1"/>
        <rect x="0" y="2" width="8" height="2"/>
      </g>
      <rect x="2" y="2" width="1" height="2" fill="#fff"/>
      <rect x="5" y="2" width="1" height="2" fill="#fff"/>
      <g fill="#FFF"><rect x="2" y="4" width="4" height="3"/></g>
    </Sprite>
  );

  const Bolt = (props) => (
    <Sprite color="#FDB115" glow="rgba(253,177,21,0.65)" {...props}>
      <g fill="currentColor">
        <rect x="3" y="0" width="3" height="1"/>
        <rect x="2" y="1" width="3" height="1"/>
        <rect x="2" y="2" width="2" height="1"/>
        <rect x="1" y="3" width="5" height="1"/>
        <rect x="3" y="4" width="2" height="1"/>
        <rect x="3" y="5" width="1" height="1"/>
        <rect x="2" y="6" width="1" height="1"/>
      </g>
    </Sprite>
  );

  const Skull = (props) => (
    <Sprite color="#fff" {...props}>
      <g fill="currentColor">
        <rect x="2" y="0" width="4" height="1"/>
        <rect x="1" y="1" width="6" height="3"/>
        <rect x="2" y="4" width="4" height="2"/>
        <rect x="2" y="6" width="1" height="1"/><rect x="4" y="6" width="1" height="1"/>
      </g>
      <rect x="2" y="2" width="1" height="1" fill="#FD1491"/>
      <rect x="5" y="2" width="1" height="1" fill="#FD1491"/>
    </Sprite>
  );

  const Arrow = ({ size = 14, color = "currentColor" }) => (
    <svg width={size} height={size} viewBox="0 0 8 8" style={{ shapeRendering: "crispEdges" }}>
      <g fill={color}>
        <rect x="4" y="1" width="1" height="1"/>
        <rect x="4" y="2" width="2" height="1"/>
        <rect x="0" y="3" width="7" height="2"/>
        <rect x="4" y="5" width="2" height="1"/>
        <rect x="4" y="6" width="1" height="1"/>
      </g>
    </svg>
  );

  const Cart = (props) => (
    <Sprite color="#4FFD15" glow="rgba(79,253,21,0.5)" {...props}>
      <g fill="currentColor">
        <rect x="0" y="1" width="1" height="1"/>
        <rect x="1" y="2" width="6" height="1"/>
        <rect x="1" y="3" width="1" height="2"/>
        <rect x="6" y="3" width="1" height="2"/>
        <rect x="2" y="3" width="4" height="2"/>
        <rect x="2" y="6" width="1" height="1"/>
        <rect x="5" y="6" width="1" height="1"/>
      </g>
    </Sprite>
  );

  const Book = (props) => (
    <Sprite color="#00E8CB" {...props}>
      <g fill="currentColor">
        <rect x="1" y="0" width="6" height="7"/>
      </g>
      <rect x="3" y="0" width="1" height="7" fill="#15001E"/>
      <rect x="2" y="2" width="1" height="1" fill="#15001E"/>
      <rect x="5" y="2" width="1" height="1" fill="#15001E"/>
      <rect x="2" y="4" width="1" height="1" fill="#15001E"/>
      <rect x="5" y="4" width="1" height="1" fill="#15001E"/>
    </Sprite>
  );

  const Crown = (props) => (
    <Sprite color="#FDB115" glow="rgba(253,177,21,0.6)" {...props}>
      <g fill="currentColor">
        <rect x="0" y="1" width="1" height="2"/>
        <rect x="3" y="0" width="2" height="2"/>
        <rect x="7" y="1" width="1" height="2"/>
        <rect x="1" y="3" width="6" height="2"/>
        <rect x="1" y="5" width="6" height="1"/>
      </g>
      <rect x="2" y="5" width="1" height="1" fill="#FD1491"/>
      <rect x="5" y="5" width="1" height="1" fill="#00E8CB"/>
    </Sprite>
  );

  const Pad = (props) => (
    <Sprite color="#FD1491" {...props}>
      <g fill="currentColor">
        <rect x="0" y="2" width="8" height="4"/>
        <rect x="1" y="1" width="6" height="1"/>
        <rect x="1" y="6" width="6" height="1"/>
      </g>
      <rect x="1" y="3" width="1" height="2" fill="#fff"/>
      <rect x="0" y="4" width="3" height="0" fill="#fff"/>
      <rect x="2" y="3" width="1" height="2" fill="#fff"/>
      <rect x="6" y="3" width="1" height="1" fill="#FDB115"/>
      <rect x="5" y="4" width="1" height="1" fill="#00E8CB"/>
    </Sprite>
  );

  return { Heart, Coin, Star, Diamond, Joystick, Mushroom, Bolt, Skull, Arrow, Cart, Book, Crown, Pad };
})();

export default PixelIcons;
